module.exports = __webpack_public_path__ + "static/images/event/Gas-pump.png";